import type { ModuleOptions } from '@nuxt/ui';

/**
 * Creates compound variants for consistent focus ring styling across input-like components.
 * Applies `focus-visible:ring-2 focus-visible:ring-primary` to all colors on outline and subtle variants.
 */
export function createFocusRingCompoundVariants(options: Required<ModuleOptions>) {
	return (options.theme.colors || []).map((color: string) => ({
		color,
		variant: ['outline', 'subtle'] as const,
		class: {
			base: 'focus-visible:ring-2 focus-visible:ring-primary',
		},
	}));
}

/**
 * Creates compound variants for consistent outline-based focus styling.
 * Applies `focus-visible:outline-2` to all theme colors.
 *
 * Use this for components like solid Button, Switch, and Checkbox where
 * NuxtUI uses outline instead of ring for focus indicators.
 * Note: Only overrides width, not color (NuxtUI already sets outline-primary).
 */
export function createOutlineFocusVariants(options: Required<ModuleOptions>) {
	return (options.theme.colors || []).map((color: string) => ({
		color,
		class: 'focus-visible:outline-2',
	}));
}

// Menu-family item styling

export const itemHighlighted = 'data-highlighted:not-data-disabled:text-highlighted data-highlighted:not-data-disabled:before:bg-elevated';

export const itemDisabled = 'data-disabled:opacity-100 data-disabled:text-disabled';

export const itemLeadingIcon = 'text-toned group-data-disabled:text-disabled';

export const destructiveItem = 'text-error data-highlighted:not-data-disabled:text-(--ui-error-highlighted) data-highlighted:not-data-disabled:before:bg-error-50 dark:data-highlighted:not-data-disabled:before:bg-error-900 data-disabled:text-disabled';

export const destructiveItemLabel = 'text-error group-data-disabled:text-disabled group-data-highlighted:not-group-data-disabled:text-(--ui-error-highlighted)';

export const destructiveItemLeadingIcon = 'text-error group-data-disabled:text-disabled group-data-highlighted:not-group-data-disabled:text-(--ui-error-highlighted)';

// Folded breadcrumb popover button styling

export const breadcrumbButtonFolded = 'w-full justify-start gap-2 rounded-md p-1.5 text-sm font-normal text-default hover:text-highlighted';

// Overlay styling

export const overlayBackdrop = 'bg-black/60 dark:bg-black/75';
